import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-member-list",
  "use": "icon-member-list-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-member-list\"><path d=\"M512.09 596.34c165.79 0 300.88-133.824 300.88-298.17C812.788 133.644 677.88 0 512.09 0S211.211 133.644 211.211 298.17c0 164.346 134.908 298.17 300.88 298.17z m363.728 134.727c-43.163-78.38-104.025-141.229-176.265-181.502-10.114-5.599-22.756-3.793-30.702 4.515L511.91 716.258 354.969 554.08c-7.947-8.308-20.589-10.114-30.702-4.515C252.027 590.019 191.165 652.687 148 731.067 104.116 810.892 81 903.54 81 998.897c0 13.906 11.378 25.103 25.284 25.103h811.615c13.906 0 25.284-11.197 25.284-25.103 0-95.357-23.298-188.005-67.364-267.83z\" p-id=\"4901\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/member-list.svg
// module id = Ig0j
// module chunks = 56